import script from "./RegMani.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegMani.vue?vue&type=script&lang=ts&setup=true"

import "./RegMani.vue?vue&type=style&index=0&id=72de1e92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72de1e92"]])

export default __exports__